import AutocompleteInput from '@Components/AutocompleteInput';

import FormComponent from './FormComponent';

export default class AutocompleteInputForm extends FormComponent {
  static Pure = ({ onChange, ...props }) => <AutocompleteInput
    {...props}
    onChange={value => onChange(value)}
  />
}

AutocompleteInputForm.extendDefaultProps = {
  defaultClassName: 'form-control',
}
